import AkkaLink from '@commons/AkkaLink/AkkaLink';

/**
 * Blurb link wrapper that makes content clickable.
 * Use this to wrap the entire Blurb or specific parts.
 * An overlay link has no visible content, so its children are the accessible name.
 */
export default function BlurbLink({ href, onClick = undefined, children, className = '', overlay = false }) {
  if (!href) return children;

  const overlayClass = overlay ? 'Blurb__link--overlay' : '';
  const finalClassName = `Blurb__link ${overlayClass} ${className}`.trim();

  return (
    <AkkaLink href={href} onClick={onClick} className={finalClassName}>
      {overlay && children ? <span className="visually-hidden">{children}</span> : children}
    </AkkaLink>
  );
}
